import React, {Fragment} from 'react';
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import {AccessRights, PARTS} from '../../schemas/accessRightsModel';
import JobBoardFiltersButton from "./jobBoardFilters/JobBoardFiltersButton";
import {setJobBoardSortBy} from "./JobBoardActions";
import {toggleJobBoardSortArrayValue} from "../../utilities/job";

const JobBoardSortPanel = (props) => {

  const {AR, editableQuote, setJobBoardSortBy, sortBy, showAssociateColumn} = props;

  if (editableQuote) {
    return null
  }

  const isSelectedSortTab = (sortTabId) => {
    return sortBy.find(filter => filter.name === sortTabId)
  }

  const sortButtonClick = (sortTabId) => {
    setJobBoardSortBy(toggleJobBoardSortArrayValue(sortBy, sortTabId))
  }

  const sortPanelButtons = ["name", "jobType", "status", "salesPerson", "appointmentDate", "store", "daysOpen"];
  if (showAssociateColumn) {
    sortPanelButtons.splice(6, 0, "associate");
  }
  if (AR.v(PARTS.JOB_SHOW_PRICE)) {
    sortPanelButtons.push("notesUploads");
    sortPanelButtons.push("amount");
  }

  const allowedToClickButtons = ["appointmentDate", "daysOpen"];

  return (
    <div className="app-content-header">
      <div className="job-board-sort-bar">
        <JobBoardFiltersButton/>
        {sortPanelButtons.map(sortTabId => {
          const selectedSortTab = isSelectedSortTab(sortTabId)
          return (
            <div className="job-board-sort-bar-col" key={sortTabId}>
              {allowedToClickButtons.includes(sortTabId) ? (
                <div className="sort-content" onClick={() => sortButtonClick(sortTabId)}>
                <span className={"sort-content__text" + (selectedSortTab ? " sort-content__text--with-triangle" : "")}>
                  {selectedSortTab ? <span className={"sort-content__text-triangle"
                  + (selectedSortTab.value === "desc" ? " sort-content__text-triangle--rotated" : "")}/> : null}
                  <FormattedMessage id={"jobBoard.sortPanel." + sortTabId}/>
                </span>
                </div>
              ) : (
                <FormattedMessage id={"jobBoard.sortPanel." + sortTabId}/>
              )}
            </div>
          )
        })}
        <div className="job-board-sort-bar-dashed-line"/>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {filters, editableQuote, sortBy} = store.jobBoard;
  return {
    language: store.dashboardState.language,
    AR: AccessRights.get(store),
    filters,
    editableQuote,
    sortBy
  };
};

const mapDispatchToProps = {
  setJobBoardSortBy
};

export default connect(mapStateToProps, mapDispatchToProps)(JobBoardSortPanel);
